export const getAspectRatio = (width: number, height: number): string => {
    return reduceRatio(width, height);
};

/**
 * Reduce a numerator and denominator to it's smallest, integer ratio using Euclid's Algorithm
 */
function reduceRatio(numerator: number, denominator: number) {
    var gcd: Function, temp, divisor;
    // from: http://pages.pacificcoast.net/~cazelais/euclid.html
    gcd = function (a: number, b: number) {
        if (b === 0) return a;
        return gcd(b, a % b);
    };
    // take care of some simple cases
    if (!isInteger(numerator) || !isInteger(denominator)) return "? : ?";
    if (numerator === denominator) return "1 : 1";
    // make sure numerator is always the larger number
    if (+numerator < +denominator) {
        temp = numerator;
        numerator = denominator;
        denominator = temp;
    }
    divisor = gcd(+numerator, +denominator);
    return "undefined" === typeof temp
        ? numerator / divisor + " : " + denominator / divisor
        : denominator / divisor + " : " + numerator / divisor;
}

function isInteger(value: any) {
    return /^[0-9]+$/.test(value);
}
